// ReportModal.jsx
import React from "react";
import Modal from "../elements/Modal";

const ModelsModal = ({ isOpenModels, setIsOpenModels }) => {
	return (
		<Modal isOpen={isOpenModels} className="Modal__sponsor-container">
			<div className="sponsor-modal">
				<div className="sponsor-modal__header">
					<p className="left">Information</p>
					<div
						className="sponsor-modal__close"
						onClick={() => setIsOpenModels(false)}
					>
						<i className="fa fa-times"></i>
					</div>
				</div>
				<div class="sponsor-modal__content">
					<h2 class="article-title center">
						Why Global and Local Models?
					</h2>
					<p class="article-text">
						Global models have demonstrated significant
						effectiveness when tested in Europe. This success is
						attributed to the richer European horse databases used
						for training. However, performance declined noticeably
						when these models were tested in other regions,
						highlighting the need for localized models. The newly
						released Australia/New Zealand models now exhibit even
						greater precision than the original models.
					</p>

					<h2 class="article-title">What Do the Models See?</h2>
					<p class="article-text">In the Global models:</p>
					<ul class="model-list">
						<li class="model-item">
							<strong>Model 1, 2, and 3:</strong> predict the
							likelihood of horses becoming top performers at
							different distances.
						</li>
						<li class="model-item">
							<strong>Model 4:</strong> focuses on avoiding low
							performers.
						</li>
						<li class="model-item">
							<strong>Model 5:</strong> consolidates insights from
							the other models to optimize performance.
						</li>
					</ul>

					<p class="article-text">
						The local models for Australia/New Zealand are designed
						to be more consistent:
					</p>
					<ul class="model-list">
						<li class="model-item">
							<strong>Model 1:</strong> identifies great
							performers at any age.
						</li>
						<li class="model-item">
							<strong>Model 2:</strong> identifies great
							performers at age 2.
						</li>
						<li class="model-item">
							<strong>Model 3:</strong> avoids low performers at
							age 2.
						</li>
						<li class="model-item">
							<strong>Model 4:</strong> avoids low performers at
							any age.
						</li>
						<li class="model-item">
							<strong>Model 5:</strong> integrates all models to
							provide the best potential results.
						</li>
					</ul>

					<p class="article-text">
						These models concentrate on distances below a mile,
						reflecting the emphasis on speed in Australian racing.
						For longer distances, Model 3 from the Global set is
						recommended, as it has maintained its precision in
						Australian tests.
					</p>

					<div class="note">
						<p class="note-text">
							<strong>Note:</strong> When referring to Models 3
							and 4 as avoiding low performers, a high score in
							these models indicates a lower likelihood of
							selecting low performers.
						</p>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default ModelsModal;
